import { render, staticRenderFns } from "./OrderArea.vue?vue&type=template&id=57316eb2&"
import script from "./OrderArea.vue?vue&type=script&lang=ts&"
export * from "./OrderArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports